module.exports = __webpack_public_path__ + "images/jcb-1a_yRqk.svg";